<template>
    <div>

      <div class="row">

        <div class="col-md-12" v-if="isEdit">
        </div>

      </div>
    <div>
    <div class="row" v-if="model.is_sending">
      <div class="col-md-offset-1 col-md-10">
        <div class="card">
          <div class="sending-campaign display-flex">
            <h4>{{$t('marketingCampaigns.cannotModify')}}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1"> -->
      <div class="col-md-offset-1 col-md-10">
        <div class="card card-wizard marketing-wizard access-vue-form-wizard" id="wizardCard">
          <form-wizard shape="square"
                      step-size="xs"
                       @on-complete="wizardComplete"
                       error-color="#EB5E28"
                       color="#5e35b1">

            <tab-content :before-change="validateFirstStep" title="Campaign Details">
              <first-step ref="firstStep" :modelFromParent="model" :daysParent="days"></first-step>
            </tab-content>

            <!-- <tab-content :before-change="validateSecondStep" title="Notifications">
              <second-step ref="secondStep" :modelFromParent="model" :daysParent="days"></second-step>
            </tab-content> -->

            <tab-content :before-change="validateThirdStep" title="Target">
              <third-step ref="thirdStep"
                @groupCustomers="handleGroupCustomers"
                :userLabels="userLabels"
                :modelFromParent="model"
                :customerGroups="customerGroups"
                :daysParent="days">
              </third-step>
            </tab-content>

            <tab-content :before-change="validateCouponStep" :title="$t('pages.coupons')">
              <coupon-select-step ref="couponStep" :modelFromParent="model"></coupon-select-step>
            </tab-content>

            <h2 slot="title"></h2>
            <button slot="prev" class="btn btn-purple-light btn btn-wd btn-back">{{$t('general.back')}}</button>
            <button slot="next" class="btn btn-purple-light btn-fill btn-wd btn-next">{{$t('general.next')}}</button>
            <button slot="finish" class="btn btn-purple-light btn-fill btn-wd" :disabled="model.is_sending">{{$t('general.finish')}}</button>
          </form-wizard>
        </div>
      </div>
    </div>

  </div>
</div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select, TimeSelect} from 'element-ui'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import FirstStep from './Steps/FirstStep.vue'
  // import SecondStep from './Steps/SecondStep.vue'
  import ThirdStep from './Steps/ThirdStep.vue'
  import CouponSelectStep from './Steps/CouponSelectStep.vue'
  import countriesList from './../../Customers/countries'
  import moment from 'moment'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [TimeSelect.name]: TimeSelect,
      [Select.name]: Select,
      FormWizard,
      TabContent,
      FirstStep,
      // SecondStep,
      ThirdStep,
      CouponSelectStep
    },
    computed: {
      ...mapFields(['name', 'price', 'active', 'date_from'])
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
        countries: countriesList,
        userLabels: [],
        userLabelLevels: [],
        model: [],
        customerList: 0,
        modelValidations: {
          name: {
            required: true,
            min: 4
          },
          active: {
            required: true
          },
          price: {
            required: true
          },
          status: {
            required: true
          },
          date_from: {
          },
          coupon_code: {
            required: true,
            min: 4
          },
          coupon_option: {
          }
        },
        wizardModel: {},
        customerGroups: [],
        selectedCustomerGroups: []
      }
    },
    created () {
      this.getData()
      this.getGroups()
    },
    methods: {
      handleGroupCustomers (e) {
        this.selectedCustomerGroups = e
      },
      getData () {
        this.defineDataModels()
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.getDataOnEdit(data)
        // this.getCategories(data)
        this.getUserLabeling(data)
      },
      getDataOnEdit (data) {
        const editId = this.route.params && this.route.params.id
        const duplicateFrom = (this.route.query && this.route.query.duplicateFrom) ||
          (this.$route.query && this.$route.query.duplicateFrom)
        const sourceId = editId || duplicateFrom
        if (sourceId) {
          const id = sourceId
          this.apiRequest('/campaign/' + id, 'GET', data, response => {
            if (response.status === true) {
              // get valid date
              if (response.data[0].datetime_validfrom && response.data[0].datetime_validto) {
                response.data[0].fromto = [response.data[0].datetime_validfrom, response.data[0].datetime_validto]
              }

              // image object
              if (response.data[0]['image_url']) {
                response.data[0]['imagelist'] = response.data[0]['image_url']
              } else {
                response.data[0]['imagelist'] = []
              }

              // notifications time object
              const notifTimes = response.data[0]['notification_times']
              const dayData = []
              for (const day in this.days) {
                var checked = false
                var hourTo = ''
                var hourFrom = ''
                for (var nTime of notifTimes) {
                  if (nTime.day === this.days[day]) {
                    checked = true
                    hourTo = nTime.hour_to
                    hourFrom = nTime.hour_from
                  }
                }
                dayData.push({day: this.days[day], hour_to: hourTo, hour_from: hourFrom, checked: checked})
              }
              response.data[0]['notification_times_array'] = dayData
              var notifTypesArray = []
              var notifTypes = response.data[0]['notification_type']
              for (var type in this.campaignsNotificationTypes) {
                notifTypesArray.push({type: false})
                if (notifTypes !== null) {
                  for (var nType of notifTypes) {
                    if (nType.type === type) {
                      notifTypesArray[type] = true
                    }
                  }
                }
              }
              response.data[0]['notification_types_array'] = notifTypesArray
              // get model
              this.model = response.data[0]
              if (duplicateFrom && !editId) {
                this.prepareDuplicatedCampaign()
              }
            }
          })
        }
      },
      prepareDuplicatedCampaign () {
        if (!this.model || typeof this.model !== 'object') {
          return
        }
        const originalName = this.model.name || ''
        delete this.model.id
        delete this.model.sent
        delete this.model.notif_sent
        delete this.model.email_sent
        delete this.model.counter
        delete this.model.last_sent
        delete this.model.in_queue
        delete this.model.total_notificatios_to_be_sent
        delete this.model.created_at
        delete this.model.updated_at
        delete this.model.deleted_at
        delete this.model.created_by
        delete this.model.updated_by
        delete this.model.deleted_by
        this.model.is_sending = false
        this.model.active = false
        this.model.name = originalName
          ? originalName + ' <Copie>'
          : '<Copie>'
      },
      defineDataModels () {
        var notifTimes = []
        var dayData = []
        for (var day in this.days) {
          var dayDataIdx = this.getObjectByElemKeyValue('day', this.days[day], notifTimes)
          if (dayDataIdx !== undefined && notifTimes[dayDataIdx] !== undefined) {
            notifTimes[dayDataIdx]['checked'] = true
            dayData.push(notifTimes[dayDataIdx])
          } else {
            dayData.push({day: this.days[day], hour_to: '', hour_from: '', checked: false})
          }
        }
        var notifTypesArray = []
        for (var type in this.campaignsNotificationTypes) {
          notifTypesArray[type] = false
        }
        this.model = {
          notification_times_array: dayData,
          notification_types_array: notifTypesArray,
          user_filters: {
            age: '',
            gender: '',
            orders_above: '',
            location_id: '',
            user_label_id: '',
            counter_matching_users: 0
          },
          type_push: 1,
          link_type: 1,
          url: null,
          email_json: null,
          user_label_id: null,
          imagelist: [],
          type: 'TEXT',
          coupon_id: null
        }
      },
      getUserLabeling (data) {
        this.apiRequest('/userlabeling', 'GET', data, response => {
          if (response.status === true) {
            this.userLabels = response.data.items
            this.userLabelLevels = response.data.items.map(el => ({
              key: el.id,
              label: el.name
            }))
          }
        })
      },
      isEdit () {
        if (this.route.params.id) {
          return true
        } else {
          return false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      validateFirstStep () {
        this.model = {...this.$refs.firstStep.model}
        return this.$refs.firstStep.validate()
      },
      // validateSecondStep () {
      //   this.model = {...this.$refs.secondStep.model}
      //   return this.$refs.secondStep.validate()
      // },
      validateThirdStep () {
        var ret = this.$refs.thirdStep.validate()
        this.model = {...this.$refs.thirdStep.model}
        return ret
      },
      validateCouponStep () {
        this.model = {...this.$refs.couponStep.model}
        return this.$refs.couponStep.validate()
      },
      handleRemoveImage (file, fileList) {
      },
      filterCustomers () {
        this.customerList = 30
      },
      resetTable () {
        this.customerList = 0
      },
      sanitizeGroups (groups) {
        if (!groups.length) return null
        let res = []
        Object.entries(groups).forEach(([key, value]) => {
          res.push(groups[key].id)
        })
        return res
      },
      wizardComplete () {
        // we gather models from all steps into one model
        // this.model = {
        //   ...this.$refs.firstStep.model,
        //   ...this.$refs.secondStep.model,
        //   ...this.$refs.thirdStep.model,
        //   ...this.$refs.forthStep.model
        // }

        // var go = false

        var self = this
        var data = this.copyObject(this.model)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')

        // the campaign only announces a coupon; the discount is applied from the coupon itself
        data.coupon_id = this.model.coupon_id || null
        data.type = data.coupon_id ? 'COUPON' : 'TEXT'
        delete data.coupon
        delete data.order_source_ids
        delete data.order_sources_mask

        if (this.model.fromto && this.model.fromto[0] && this.model.fromto[1]) {
          data.datetime_validfrom = moment(this.model.fromto[0], moment.ISO_8601).format()
          data.datetime_validfrom = data.datetime_validfrom.slice(0, data.datetime_validfrom.indexOf('+'))
          data.datetime_validfrom = data.datetime_validfrom.replace('T', ' ')
          data.datetime_validto = moment(this.model.fromto[1], moment.ISO_8601).format()
          data.datetime_validto = data.datetime_validto.slice(0, data.datetime_validto.indexOf('+'))
          data.datetime_validto = data.datetime_validto.replace('T', ' ')
        } else {
          data.datetime_validfrom = null
          data.datetime_validto = null
        }

        var notificationTimes = []
        for (var timeKey in data.notification_times_array) {
          if (data.notification_times_array[timeKey].checked === true) {
            notificationTimes.push({day: data.notification_times_array[timeKey].day, hour_to: '', hour_from: data.notification_times_array[timeKey].hour_from})
          }
        }

        var notificationTypes = []
        for (let type in data.notification_types_array) {
          if (data.notification_types_array[type] === true) {
            notificationTypes.push({'type': type})
          }
        }

        data.user_filters.counter_matching_users = data.counter_matching_users

        if (data.description === {}) {
          data.description = ''
        }

        data.email_html = JSON.stringify(data.email_html)
        data.email_json = JSON.stringify(data.email_json)

        delete data.notification_times_array
        delete data.notification_types_array
        delete data.notification_times
        delete data.notification_type
        delete data.fromto
        const existingImageUrl = data.image_url
        delete data.image_url
        delete data.deleted_at
        delete data.created_at
        delete data.updated_at
        delete data.created_by
        delete data.deleted_at
        delete data.deleted_by
        delete data.updated_by
        delete data.counter_matching_users
        data.notification_times = JSON.stringify(notificationTimes)
        data.user_filters = JSON.stringify(data.user_filters)
        data.notification_type = JSON.stringify(notificationTypes)
        // if (!go) {
        //   return false
        // }
        // save
        if (!this.route.params.id) {
          const hasNewImage = data.imagelist && Object.keys(data.imagelist).length && data.imagelist[0].status === 'ready'
          if (!hasNewImage && existingImageUrl) {
            data.image_url = existingImageUrl
          }
          this.apiRequest('/campaign', 'POST', data, function (response) {
            if (response.status === true) {
              var id = response.data[0].id
              if (Object.keys(data.imagelist).length && data.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.name = data.name
                    data2.type = data.type
                    data2.mode = data.mode
                    data2.notification_type = data.notification_type
                    data2.image = base64enc
                    self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.goBack()
                      } else {
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingCampaigns.campaignPhotoError'),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.goBack()
              }
            }
          })
        } else {
          var id = this.route.params.id
          // check if the've removed the picture
          if (data.imagelist === 0) {
            data.image_url = ''
          }
          this.apiRequest('/campaign/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              if (Object.keys(data.imagelist).length && data.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    data2.name = data.name
                    data2.type = data.type
                    data2.mode = data.mode
                    data2.notification_type = data.notification_type
                    self.apiRequest('/campaign/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.goBack()
                      } else {
                        swal(
                          {
                            title: '',
                            text: self.$t('marketingCampaigns.campaignPhotoError'),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.goBack()
              }
            } else {
              // self.handleErrors(response.errors)
            }
          }) // end api response
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      getGroups () {
        var self = this
        this.loading = true
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/customersgroup/get-groups', 'POST', data, function (response) {
          if (response.status === true) {
            self.customerGroups = response.data
          }
          self.$nextTick(function () { self.loading = false })
        })
      }
    }
  }
</script>
<style>
  .sending-campaign {
    justify-content: center;
    padding: 0 0 10px 0;
    color: red;
  }
  .upload-demo input[type="file"]{ display: none; }
  .el-date-editor.el-input{ max-width: 170px; }
  .padd{ padding: 4px 15px; }
  .el-select{ width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/CampaignForm.vue